const middlewares = require(`./${process.env.NODE_ENV}`).default;

export default middlewares;
export { sagaMiddleware, runSaga, } from './sagaMiddleware';
